import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { Switch, Router } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import UnauthenticatedLayout from '../layout/unauthenticatedLayout';
import UnauthenticatedRoute from '../components/UnauthenticatedRoute';
import AuthenticatedLayout from '../layout/authenticatedLayout';

const SignIn = lazy(() => import('../pages/SignIn'));

const Routes = (props) => {
   let history = useHistory();

   return (
      <Router history={history}>
         <Suspense fallback={<div>Loading...</div>}>
            <Switch>
               <UnauthenticatedRoute
                  exact={true}
                  path="/"
                  render={(props) => (
                     <UnauthenticatedLayout history={props.history}>
                        <SignIn {...props} />
                     </UnauthenticatedLayout>
                  )}
               />
               <AuthenticatedLayout />
            </Switch>
         </Suspense>
      </Router>
   );
};

const mapStateToProps = ({ authReducer }) => {
   return {
      isLoggedIn: authReducer.isLoggedIn,
   };
};

export default connect(mapStateToProps)(Routes);
